import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[appBlockPaste]',
  standalone: false
})
export class BlockPasteDirective {
  constructor() {}

  @HostListener('paste', ['$event']) blockPaste(e: KeyboardEvent) {
    e.preventDefault();
  }
}
